
module.exports.deprecate = function() {};
module.exports.printDeprecationMessage = function() {};
module.exports.debuglog = function() {
  return function() {};
};



// WEBPACK FOOTER //
// ./src/util.js